import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Fires a Meta Pixel PageView on client-side navigation.
// The base script in public/index.html already covers the initial load,
// and GA4 Enhanced Measurement handles its own history-change page_views.
const RouteTracker = () => {
  const { pathname } = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [pathname]);

  return null;
};

export default RouteTracker;